import styled from 'styled-components';

import { StyledCoreDropdown } from 'modules/queryBuilder/legacyQueryBuilder/components/comparatorDropdown/ComparatorDropdown.styled';
import { QueryBuilderContainer } from 'modules/queryBuilder/legacyQueryBuilder/components/QueryBuilder.styled';
import { FieldContainer } from 'modules/queryBuilder/legacyQueryBuilder/components/criteriaPropertyGroup/CriteriarPropertyGroup.styled';

export const QueryBuilderWrapper = styled.div`
  padding-top: ${({ theme }) => theme.spacing.values.plusHalf};
  ${QueryBuilderContainer} {
    ${FieldContainer} {
      flex-wrap: wrap;
      margin-right: ${({ theme }) => theme.spacing.utils.pxToRem(10)};
      ${StyledCoreDropdown} {
        margin-right: 0;
      }
      > * {
        .ui.dropdown {
          border-radius: 0;
          margin-bottom: -${({ theme }) => theme.spacing.values.single} !important;
          margin-right: 0 !important;
          flex: 1 1 auto;
        }
        margin-bottom: -${({ theme }) => theme.spacing.values.single} !important;
      }
      .cssCriteriaPropertyGroupFieldDropdown {
        margin-right: -${({ theme }) => theme.spacing.values.single} !important;
        min-width: 60%;
        & [role='alert'] div.cssDropdownItemText {
          max-width: ${({ theme }) => theme.spacing.utils.pxToRem(400)};
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        & [role='option'] > div {
          overflow: hidden;
          word-break: break-word;
        }
      }
    }
  }
`;
